import { Stack, Typography } from "@mui/material";
import { type Control, useController } from "react-hook-form";
import { MerchantUserAutocomplete } from "Components/Shared/Inputs/MerchantUserAutocomplete";
import { Resources, useResource } from "Translations/Resources";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import type { CampaignFormData } from "./campaignFormSchema";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  control: Control<CampaignFormData>;
  isSubmitting: boolean;
  campaign?: AdminCampaignDto;
};

export const PaymentReceiverSection = ({
  control,
  isSubmitting,
  campaign,
}: Props) => {
  const { t } = useResource();
  const {
    field: receiverUserField,
    fieldState: { error },
  } = useController({ control, name: "receiverUserID" });
  const { field: receiverIdentityUserField } = useController({
    control,
    name: "receiverIdentityUserID",
  });

  const receiverUserID = receiverUserField.value;

  return (
    <Stack gap={3}>
      <Typography variant="h6" fontWeight={600}>
        {t(RESOURCES.PaymentReceiver)}
      </Typography>

      <MerchantUserAutocomplete
        name={receiverUserField.name}
        label={t(RESOURCES.MerchantUser)}
        disabled={isSubmitting}
        value={
          receiverUserID
            ? {
                userID: receiverUserID,
                identityUserID: receiverIdentityUserField.value,
              }
            : null
        }
        onChange={(merchant) => {
          receiverUserField.onChange(merchant?.userID ?? null);
          receiverIdentityUserField.onChange(merchant?.identityUserID ?? null);
        }}
        errorMessage={error?.message}
        initialMerchant={campaign?.receiverMerchantUser}
      />
    </Stack>
  );
};
